import { Typography } from '@mui/material';
import React from 'react';

const Payment = () => {
    return (
        <div>
            <Typography variant="h4" color="text.secondary" sx={{ my: 4 }}>
                Payment system coming soon.
            </Typography>
        </div>
    );
};

export default Payment;